import React from "react";
import styled from "styled-components";

import { Sign } from "@components/organisms";

import type { FC } from "react";

type LoginPageProps = {
  redirectUrl?: string;
};

const Login: FC<LoginPageProps> = ({ redirectUrl }) => {
  return (
    <Container>
      <Sign redirectUrl={redirectUrl} />
    </Container>
  );
};

const Container = styled.div`
  position: relative;

  width: 100%;
  height: 100vh;

  display: flex;
  align-items: center;
  flex-direction: column;
`;

export default Login;
